import * as React from 'react'
import { ReactElement } from 'react'
import { ListItemDto } from '../../config/partyConfig'
import useEntity from '../../hooks/useEntity'
import EntityCombobox, { EntityComboboxProps } from './EntityCombobox'

type Props = Omit<EntityComboboxProps<ListItemDto>, 'getEntityLabel' | 'getEntityValue' | 'dataPromise'>

export default function PartyCombobox(props: Props): ReactElement {
    const [parties] = useEntity<ListItemDto[]>(() => ({ url: '/party' }), false)

    return (
        <EntityCombobox<ListItemDto>
            dataPromise={parties}
            getEntityLabel={user => user.displayName.replaceAll('\n', ' ')}
            getEntityValue={user => user.id}
            placeholderKey={'base.partycombobox.placeholder'}
            {...props}
        />
    )
}
